import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;

import backbone from 'backbone';
window.Backbone = backbone;

import moment from 'moment';
window.moment = moment;

import key from 'keymaster';
window.key = key;

import underscore from 'underscore';
window._ = underscore;
